import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: "My child's therapist handles this.",
    a: "Therapists work in 50-minute sessions once a week. You work in real time, every day. This system is built for the moment between sessions — the 6:52 PM Tuesday that can't wait until next Thursday."
  }, {
    q: "I've tried everything. Nothing works.",
    a: "Everything you've tried was likely reactive — designed for after the meltdown starts. The Crisis Calm Method operates in the yellow zone, before the point of no return. That is a fundamentally different approach."
  }, {
    q: 'My child is too severe for a guide like this.',
    a: 'The three core stages work across all levels of the spectrum ages 3–12. The principles are neurological, not behavioral. If your child has a nervous system, this applies.'
  }, {
    q: "I don't have time to read a whole book.",
    a: 'The core protocol is three pages. The Yellow Zone Cheat Sheet is one page. You can have the system in your hands before tonight.'
  }, {
    q: 'Is this scientifically backed?',
    a: 'Every principle in this guide is grounded in sensory integration theory, polyvagal theory and co-regulation research. The language is plain. The science is solid.'
  }, {
    q: "What if it doesn't work for us?",
    a: "You have 30 days to apply it and decide. If it doesn't work, you get every dollar back. The guarantee is unconditional."
  }];
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-cream-dark" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-12 text-center" data-id="element-29">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-31" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-2xl shadow-sm border border-cream overflow-hidden" data-id="element-32">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-33">
        <span className="font-serif text-xl text-charcoal pr-8" data-id="element-34">
          {question}
        </span>
        <ChevronDown className={`w-6 h-6 text-amber shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-35" />
      </button>
      <AnimatePresence data-id="element-36">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-37">
            <div className="px-6 pb-6 text-charcoal-light text-lg leading-relaxed border-t border-cream-dark pt-4" data-id="element-38">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}